import { history as UMI_history } from '@umijs/max';
import { canGoBack } from './canGoBack';

export const goBackSafe = (
  to: Parameters<typeof UMI_history.replace>[0] = '/workbench',
  state?: any,
) => {
  if (!canGoBack()) {
    UMI_history.replace(to, state);
  } else {
    UMI_history.back();
  }
};
